module.exports = __webpack_public_path__ + "static/PP4-83476c36e4b88e1f69e13bac3e7eb2f2.jpg";